/* ==========================================================================
   SLUMLY DESIGN SYSTEM — shared interaction layer
   Reveal-on-scroll, animated counters, drag-scroll carousels, video toggles
   ========================================================================== */
(function(){
  if(window.SlumlySystem) return;

  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(root){
    var els = (root || document).querySelectorAll('[data-reveal]:not(.s-in)');
    if(!els.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function(){ el.classList.add('s-in'); }, delay);
          obs.unobserve(el);
        }
      });
    }, {threshold:.15, rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(el){ obs.observe(el); });
  }

  /* ---------------- Animated counters ---------------- */
  function parseStat(raw){
    raw = (raw || '').trim();
    var m = raw.match(/^(\D*)([\d.,]+)(\D*)$/);
    if(!m) return null;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var thousands = false, decimals = 0, target;
    if(numStr.indexOf('.') > -1){
      var parts = numStr.split('.');
      var last = parts[parts.length - 1];
      if(last.length === 3){ thousands = true; target = parseFloat(parts.join('')); }
      else { decimals = last.length; target = parseFloat(numStr); }
    } else if(numStr.indexOf(',') > -1){
      var cparts = numStr.split(',');
      var clast = cparts[cparts.length - 1];
      if(clast.length === 3){ thousands = true; target = parseFloat(cparts.join('')); }
      else { decimals = clast.length; target = parseFloat(numStr.replace(',', '.')); }
    } else {
      target = parseFloat(numStr);
    }
    return {prefix:prefix, suffix:suffix, target:target, thousands:thousands, decimals:decimals};
  }

  function formatStat(val, info){
    if(info.decimals > 0) return info.prefix + val.toFixed(info.decimals) + info.suffix;
    var rounded = Math.round(val);
    var str = rounded.toString();
    if(info.thousands) str = str.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return info.prefix + str + info.suffix;
  }

  function animateCounter(el){
    var raw = el.getAttribute('data-counter');
    var info = parseStat(raw);
    if(!info || isNaN(info.target)){ el.textContent = raw; return; }
    var start = null, duration = 1500;
    function ease(t){ return 1 - Math.pow(1 - t, 3); }
    function step(ts){
      if(start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = formatStat(info.target * ease(progress), info);
      if(progress < 1) requestAnimationFrame(step);
      else el.textContent = formatStat(info.target, info);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root){
    var els = (root || document).querySelectorAll('[data-counter]:not(.s-counted)');
    if(!els.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('s-counted');
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, {threshold:.4, rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){ obs.observe(el); });
  }

  /* ---------------- Drag-scroll carousels ---------------- */
  function initDrag(root){
    var tracks = (root || document).querySelectorAll('[data-drag]:not(.s-drag-bound)');
    tracks.forEach(function(track){
      track.classList.add('s-drag-bound');
      var dragging = false, dragMoved = false, startX = 0, scrollStart = 0;
      var lastX = 0, lastT = 0, velocity = 0, momentumId = null;

      function now(){ return window.performance && performance.now ? performance.now() : new Date().getTime(); }

      track.addEventListener('pointerdown', function(e){
        dragging = true; dragMoved = false;
        startX = e.clientX; scrollStart = track.scrollLeft;
        lastX = e.clientX; lastT = now(); velocity = 0;
        track.classList.add('s-dragging');
        if(momentumId){ cancelAnimationFrame(momentumId); momentumId = null; }
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function(e){
        if(!dragging) return;
        var dx = e.clientX - startX;
        if(Math.abs(dx) > 5) dragMoved = true;
        track.scrollLeft = scrollStart - dx;
        var t = now(), dt = t - lastT;
        if(dt > 0){ velocity = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = t; }
      });

      function endDrag(){
        if(!dragging) return;
        dragging = false;
        track.classList.remove('s-dragging');
        var v = velocity;
        function step(){
          track.scrollLeft -= v * 16;
          v *= 0.94;
          if(Math.abs(v) > 0.05) momentumId = requestAnimationFrame(step);
          else momentumId = null;
        }
        if(Math.abs(v) > 0.05) momentumId = requestAnimationFrame(step);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function(){ if(dragging) endDrag(); });

      track.addEventListener('click', function(e){
        if(dragMoved){ e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ---------------- Lazy image fade-in ---------------- */
  function initImages(root){
    var imgs = (root || document).querySelectorAll('[data-fade-img]:not(.s-loaded)');
    imgs.forEach(function(img){
      if(img.complete) img.classList.add('s-loaded');
      else img.addEventListener('load', function(){ img.classList.add('s-loaded'); });
    });
  }

  /* ---------------- Init all ---------------- */
  function initAll(root){
    initReveal(root);
    initCounters(root);
    initDrag(root);
    initImages(root);
  }

  ready(function(){ initAll(document); });
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });

  window.SlumlySystem = {
    initAll: initAll,
    initReveal: initReveal,
    initCounters: initCounters,
    initDrag: initDrag,
    initImages: initImages
  };
})();
